"use strict";

/**
 *	Factory zur Konvertierung von Aktionen, die serverseitig bereitgestellt wurden in entsprechende Client-Aktionen.
 *
 *	@class
 *	@static
 *	@author	Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.action.GCServerSideActionFactory = {

	/**
	 * Erzeugt anhand der übergebenen Optionen eine Aktion.
	 *
	 * @param {Object} options
	 * @param {string} options.type Aktionstyp
	 * @return {gc.gis.action.GCAbstractAction|null}
	 */
	createAction: function (options)
	{
		var action = null;

		options.type = options.type || '';
		switch (options.type.toLowerCase())
		{
			case 'link':
				if (typeof options.request === 'string' && options.request.length > 0)
				action = new gc.gis.action.GCOpenLink({
					url: options.request,
					target: options.target,
					isModal: options.isModal
				});
				break;
		}

		return action;
	}
};